import type {
	AdminApproveAccessRequestInput,
	AdminApproveAccessRequestOutput,
	AdminDeclineAccessRequestInput,
	AdminDeclineAccessRequestOutput,
	AdminListAccessRequestsInput,
	AdminListAccessRequestsOutput,
	RequestCourseAccessInput,
	RequestCourseAccessOutput,
} from '../../types/course-access-requests.types';
import { coursesApi } from './courses-base.api';

const TAG = 'courses:access-requests' as const;
const ADMIN_INVALIDATES = [
	TAG,
	'courses:user-tags',
	'courses:courses',
	'courses:dashboard',
] as const;

export const courseAccessRequestsEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		requestCourseAccess: builder.mutation<RequestCourseAccessOutput, RequestCourseAccessInput>({
			query: ({ courseId }) => ({
				url: `courses/catalog/${encodeURIComponent(courseId)}/access-request`,
				method: 'POST',
			}),
			invalidatesTags: ['courses:courses', TAG],
		}),
		adminListAccessRequests: builder.query<
			AdminListAccessRequestsOutput,
			AdminListAccessRequestsInput
		>({
			query: (params) => ({
				url: 'courses/admin/access-requests',
				params: {
					...params,
					currentTags: params.currentTags?.join(',') || undefined,
					requestedTags: params.requestedTags?.join(',') || undefined,
				},
			}),
			providesTags: [TAG],
		}),
		adminApproveAccessRequest: builder.mutation<
			AdminApproveAccessRequestOutput,
			AdminApproveAccessRequestInput
		>({
			query: ({ id }) => ({
				url: `courses/admin/access-requests/${encodeURIComponent(id)}/approve`,
				method: 'POST',
			}),
			invalidatesTags: [...ADMIN_INVALIDATES],
		}),
		adminDeclineAccessRequest: builder.mutation<
			AdminDeclineAccessRequestOutput,
			AdminDeclineAccessRequestInput
		>({
			query: ({ id }) => ({
				url: `courses/admin/access-requests/${encodeURIComponent(id)}/decline`,
				method: 'POST',
			}),
			invalidatesTags: [TAG],
		}),
	}),
});

export const {
	useRequestCourseAccessMutation,
	useAdminListAccessRequestsQuery,
	useAdminApproveAccessRequestMutation,
	useAdminDeclineAccessRequestMutation,
} = courseAccessRequestsEndpoints;
